import { useState, useEffect } from 'react';
import { bookingService } from '../services/bookingService';

export const useBookings = (userId) => {
  const [bookings, setBookings] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(userId || null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const fetchBookings = async (isRefresh = false) => {
    if (!userId && !currentUserId) return;
    
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    setError(null);
    
    try {
      const targetUserId = userId || currentUserId;
      const data = await bookingService.getUserBookings(targetUserId);
      
      // Handle both array and object response
      if (Array.isArray(data)) {
        setBookings(data);
      } else {
        setBookings(data.bookings || []);
        setCurrentUserId(data.current_user_id || targetUserId || null);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      if (isRefresh) {
        setRefreshing(false);
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [userId, currentUserId]);

  const refreshBookings = () => {
    fetchBookings(true);
  };

  return {
    bookings,
    currentUserId,
    loading,
    refreshing,
    error,
    refreshBookings,
  };
};
